/**
 * [pug template]
 */
<template lang="pug">
  .zoom-separated.zoom-component(v-if="isActive")
    .mouse-tracker(@mousemove.stop="setZoomEvent(true, $event)", @mouseleave.stop="setZoomEvent(false)", @click="onClick")
    .zoom-lens(v-if="event", :style="{left: event.position.x + 'px', top: event.position.y + 'px', width: event.size + 'px', height: event.size + 'px' }")
    .zoom-overlay(:style="zoomStyle")
</template>
/**
 * [javascript application]
 */
<script>
import Vue from 'vue'
import ZoomLib from '../../../lib/common/zoom'

export default {
  name: 'zoom-separated',
  props: {
    image: {
      type: String,
      default: ''
    },
    isDisplayed: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      default: function () { }
    },
    firstPosition: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      over: false,
      zoomStyle: {},
      event: null,
      MaxSizeBG: null
    }
  },
  components: {},
  computed: {
    isActive: function () {
      return this.isDisplayed || this.over
    }
  },
  methods: Object.assign({}, ZoomLib, {
    /**
     * Crée le style du zoom sur place
     */
    setZoomOnItself: function () {
      if (this.MaxSizeBG == null && this.isActive && this.$el && this.$el.querySelector) {
        var ratio = 1

        if (this.event.original_size.x < this.event.original_size.y) {
          ratio =
            (
              this.$el.querySelector('.zoom-overlay').clientWidth *
              this.event.original_size.y /
              this.event.original_size.x
            ) -
            this.$el.querySelector('.zoom-overlay').clientHeight

          this.MaxSizeBG = {
            x: this.$el.querySelector('.zoom-overlay').clientWidth,
            y: this.$el.querySelector('.zoom-overlay').clientHeight + 2 * ratio
          }
        } else {
          ratio =
            (
              this.$el.querySelector('.zoom-overlay').clientHeight *
              this.event.original_size.x /
              this.event.original_size.y
            ) -
            this.$el.querySelector('.zoom-overlay').clientWidth

          this.MaxSizeBG = {
            x: this.$el.querySelector('.zoom-overlay').clientWidth + 2 * ratio,
            y: this.$el.querySelector('.zoom-overlay').clientHeight
          }
        }
      }

      if (this.MaxSizeBG) {
        Vue.set(this.zoomStyle, 'background-image', 'url("' + this.image + '")')
        Vue.set(this.zoomStyle, 'background-repeat', 'no-repeat')
        Vue.set(this.zoomStyle, 'background-size', '200%')
        Vue.set(
          this.zoomStyle,
          'background-position',
          (Math.max(-this.MaxSizeBG.x, -this.event.position.x * this.MaxSizeBG.x / (this.event.original_size.x - this.event.size))) + 'px ' +
          (Math.max(-this.MaxSizeBG.y, -this.event.position.y * this.MaxSizeBG.y / (this.event.original_size.y - this.event.size))) + 'px'
        )
      }
    }
  }),
  watch: {
    /**
     * Watcher sur le props "image"
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    image: function (newValue, oldValue) {
      this.MaxSizeBG = null
      this.zoomStyle = {}
      this.event = null
    },
    /**
     * Watcher sur le props "firstPosition"
     * Utilisé par Edge pour éviter le zoom cassé et le clignotement
     * @param {String} newValue La nouvelle valeur
     * @param {String} oldValue L'ancienne valeur
     */
    firstPosition: function (newValue, oldValue) {
      if (newValue) {
        this.over = true
        this.setupZoom(newValue)
      }
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ZoomSeparated.vue?3a3928f0